/* eslint-disable jsx-a11y/anchor-is-valid */
import { React, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaSignInAlt } from "react-icons/fa";
import { PiSignOutBold } from "react-icons/pi";
import { FiPlusCircle, FiUser } from "react-icons/fi";
import "./../style/header.css";

const Header = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [hasBusinessId, setHasBusinessId] = useState(false);
  console.log(hasBusinessId)
  const [business, setBusiness] = useState(null); // NEW

  const loadUserFromStorage = () => {
    const storedUser = localStorage.getItem("user");
    const storedBusiness = localStorage.getItem("business"); // NEW
    const storedBusinessId =
      localStorage.getItem("localbusinessId") || // preferred (what you set after fetch)
      localStorage.getItem("businessId");        // legacy/fallback

    // user
    if (storedUser) {
      try {
        const parsed = JSON.parse(storedUser);
        // you saved { message, user: {...} }
        setUser(parsed.user ?? parsed);
        setIsLoggedIn(true);
      } catch (err) {
        console.error("Error parsing user data from localStorage:", err);
        setUser(null);
        setIsLoggedIn(false);
      }
    } else {
      setUser(null);
      setIsLoggedIn(false);
    }

    // business (object)
    if (storedBusiness) {
      try {
        const parsedBiz = JSON.parse(storedBusiness);
        setBusiness(parsedBiz);
      } catch (err) {
        console.error("Error parsing business data from localStorage:", err);
        setBusiness(null);
      }
    } else {
      setBusiness(null);
    }

    // business id presence
    setHasBusinessId(!!storedBusinessId || !!(business?.id));
  };

  useEffect(() => {
    loadUserFromStorage();

    // Re-load when login code dispatches this
    const handleUserLogin = () => loadUserFromStorage();

    // Optional: also react to storage changes across tabs
    const handleStorage = (e) => {
      if (["user", "business", "localbusinessId", "businessId"].includes(e.key)) {
        loadUserFromStorage();
      }
    };

    window.addEventListener("user-login", handleUserLogin);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("user-login", handleUserLogin);
      window.removeEventListener("storage", handleStorage);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSignOut = () => {
    localStorage.clear();
    setUser(null);
    setBusiness(null);
    setIsLoggedIn(false);
    setHasBusinessId(false);
    navigate("/login");
  };

  // Helper: fallback initials if no logo
  // const BusinessBadge = () => {
  //   if (!business) return null;
  //   const name = business.business_name || "My Business";
  //   const initials = name
  //     .split(" ")
  //     .filter(Boolean)
  //     .slice(0, 2)
  //     .map((w) => w[0]?.toUpperCase())
  //     .join("");

  //   return (
  //     <button
  //       className="business-badge"
  //       onClick={() => navigate("/business-listing")}
  //       title={name}
  //       style={{
  //         display: "flex",
  //         alignItems: "center",
  //         gap: 10,
  //         // padding: "8px 12px",
  //         borderRadius: 999,
  //         background: "#f5f5f7",
  //         border: "1px solid #eee",
  //         cursor: "pointer",
  //       }}
  //     >
  //       {business.logo ? (
  //         <img
  //           src={business.logo}
  //           alt={name}
  //           onError={(e) => {
  //             e.currentTarget.style.display = "none";
  //           }}
  //           style={{
  //             width: 36,
  //             height: 36,
  //             borderRadius: "50%",
  //             objectFit: "cover",
  //             display: "block",
  //           }}
  //         />
  //       ) : (
  //         <div
  //           style={{
  //             width: 36,
  //             height: 36,
  //             borderRadius: "50%",
  //             background: "#ddd",
  //             color: "#333",
  //             display: "grid",
  //             placeItems: "center",
  //             fontWeight: 700,
  //             fontSize: 14,
  //           }}
  //         >
  //           {initials || <FiUser />}
  //         </div>
  //       )}
  //       <span
  //         style={{
  //           maxWidth: 180,
  //           whiteSpace: "nowrap",
  //           overflow: "hidden",
  //           textOverflow: "ellipsis",
  //           fontWeight: 600,
  //         }}
  //       >
  //         {name}
  //       </span>
  //     </button>
  //   );
  // };

  return (
    <header className="header">
      <div className="header-top">
        <div className="logo">
          <Link to="/">
            <img src="/images/logo-main.svg" alt="Logo" className="logo-image" />
          </Link>
        </div>

        <nav className="navigation">
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
            <li
              onClick={() => navigate("/categories")}
              style={{ cursor: "pointer" }}
            >
              <a>Categories</a>
            </li>
            <li>
              <Link to="/about-us">About Us</Link>
            </li>
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
             <li>
              <Link to="/blogs">Blogs</Link>
            </li>
          </ul>
        </nav>

        <div className="header-actions" style={{ display: "flex", alignItems: "center", gap: 12 }}>
          {/* If we have a business in storage, show its logo + name on the right */}
        


         {/* Add Listings / My Profile */}
{user && user.isListed ? (
    <button
      className="add-listing dashboard"
      onClick={() => navigate("/dashboard")}
    >
       Dashboard
    </button>
) : (
  // show Add Listings only if logged in AND no localbusinessId
  isLoggedIn &&
  !localStorage.getItem("localbusinessId") && (
    <button
      className="add-listing"
      onClick={() => navigate("/add-listing")}
    >
      <FiPlusCircle /> Add Listings
    </button>
  )
)}

         
          {/* Sign In/Sign Out */}
          {isLoggedIn ? (
            <button className="sign-in" onClick={handleSignOut}>
              <PiSignOutBold /> Sign Out
            </button>
          ) : (
            <Link to="/login" className="sign-in">
              <FaSignInAlt /> Sign in/Register
            </Link>
          )}
        </div>
      </div>

    </header>
  );
};

export default Header;
